const CRC_TABLE = new Uint32Array(256);

for (let index = 0; index < 256; index += 1) {
  let value = index;
  for (let bit = 0; bit < 8; bit += 1) {
    value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
  }
  CRC_TABLE[index] = value >>> 0;
}

const crc32 = (bytes: Uint8Array) => {
  let crc = 0xffffffff;
  for (let index = 0; index < bytes.length; index += 1) {
    crc = CRC_TABLE[(crc ^ bytes[index]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
};

const writeUint32 = (view: DataView, offset: number, value: number) => {
  view.setUint32(offset, value, true);
};

const writeUint16 = (view: DataView, offset: number, value: number) => {
  view.setUint16(offset, value, true);
};

export type ZipEntry = {
  name: string;
  bytes: Uint8Array;
};

/** Uncompressed zip. One archive is one browser download. */
export const zipStored = (entries: ZipEntry[]) => {
  const encoder = new TextEncoder();
  const locals: Uint8Array[] = [];
  const central: Uint8Array[] = [];
  let offset = 0;

  for (const entry of entries) {
    const name = encoder.encode(entry.name);
    const checksum = crc32(entry.bytes);
    const local = new Uint8Array(30 + name.length);
    const localView = new DataView(local.buffer);
    writeUint32(localView, 0, 0x04034b50);
    writeUint16(localView, 4, 20);
    writeUint16(localView, 6, 0x0800);
    writeUint16(localView, 8, 0);
    writeUint16(localView, 10, 0);
    writeUint16(localView, 12, 0);
    writeUint32(localView, 14, checksum);
    writeUint32(localView, 18, entry.bytes.length);
    writeUint32(localView, 22, entry.bytes.length);
    writeUint16(localView, 26, name.length);
    writeUint16(localView, 28, 0);
    local.set(name, 30);

    const directory = new Uint8Array(46 + name.length);
    const directoryView = new DataView(directory.buffer);
    writeUint32(directoryView, 0, 0x02014b50);
    writeUint16(directoryView, 4, 20);
    writeUint16(directoryView, 6, 20);
    writeUint16(directoryView, 8, 0x0800);
    writeUint16(directoryView, 10, 0);
    writeUint16(directoryView, 12, 0);
    writeUint16(directoryView, 14, 0);
    writeUint32(directoryView, 16, checksum);
    writeUint32(directoryView, 20, entry.bytes.length);
    writeUint32(directoryView, 24, entry.bytes.length);
    writeUint16(directoryView, 28, name.length);
    writeUint16(directoryView, 30, 0);
    writeUint16(directoryView, 32, 0);
    writeUint16(directoryView, 34, 0);
    writeUint16(directoryView, 36, 0);
    writeUint32(directoryView, 38, 0);
    writeUint32(directoryView, 42, offset);
    directory.set(name, 46);

    locals.push(local, entry.bytes);
    central.push(directory);
    offset += local.length + entry.bytes.length;
  }

  const centralSize = central.reduce((total, part) => total + part.length, 0);
  const end = new Uint8Array(22);
  const endView = new DataView(end.buffer);
  writeUint32(endView, 0, 0x06054b50);
  writeUint16(endView, 4, 0);
  writeUint16(endView, 6, 0);
  writeUint16(endView, 8, entries.length);
  writeUint16(endView, 10, entries.length);
  writeUint32(endView, 12, centralSize);
  writeUint32(endView, 16, offset);
  writeUint16(endView, 20, 0);

  return new Blob([...locals, ...central, end] as unknown as BlobPart[], {
    type: 'application/zip',
  });
};
